import TlajoLogo from '../../../../../Assets/Images/logo-02.png'
import KpiCustomGraphicBar from './KpiCustomGraphicBar'
import KpiCustomGraphicLine from './KpiCustomGraphicLine'
import KpiCustomGraphicPie from './KpiCustomGraphicPie'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import { useReactToPrint } from 'react-to-print'
import CategoriesTableAdminMasterMayor from './SubCategoriesTableAdminMasterMayor'

const monthsName = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
]

const formatNumberWithCommas = (number) => {
  if (typeof number !== 'number') return number
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const AdminMasterMayorPdfTemplate = ({
  filters = {
    array_group_category_id: null,
    date_type: 'ALL',
    year: new Date().getFullYear().toString(),
    month: null,
    week: null,
  },
  pdfController = {
    loading: false,
    hideElements: false,
    notes: null,
    dynamicTable: false,
    horizontalPage: true,
  },
  counters = {
    generated: 0,
    in_process: 0,
    resolved: 0,
    effectiveness: 0,
    web: 0,
    app: 0,
    tlajochat: 0,
    categories: [],
    categoriesOrigin: [],
    counterByDateFilter: null,
    counterByDateFilterOptions: null,
    counterByDateFilterLines: null,
    counterByDateFilterLinesOptions: null,
    countersByDateFilterPie: null,
    countersByDateFilterPieOptions: null,
  },
  options = {
    categories: [],
    years: [],
    months: [],
    weeks: [],
  },
}) => {
  const contentRef = useRef(null)
  const [isMobile, setIsMobile] = useState(false)

  const reactToPrintFn = useReactToPrint({
    contentRef,
    pageStyle: `
        @media print {
          @page {
            size: ${
              window.innerWidth <= 768
                ? pdfController.horizontalPage
                  ? 'A4 landscape' // A4 horizontal: ancho 297mm, alto 210mm
                  : 'A4' // A4 vertical: ancho 210mm, alto 297mm
                : pdfController.horizontalPage
                  ? '297mm 210mm' // A4 horizontal: ancho 297mm, alto 210mm
                  : '210mm 297mm' // A4 vertical: ancho 210mm, alto 297mm
            } !important;
            margin: 2mm 5mm !important;
          }
          body {
            -webkit-print-color-adjust: exact !important;
            color-adjust: exact !important;
          }
          .print-container {
            width: ${
              window.innerWidth <= 768
                ? '100%'
                : (pdfController.horizontalPage
                  ? '297mm'
                  : '210mm')
            } !important;
            ${
              !window.innerWidth <= 768 &&
              (pdfController.horizontalPage
                ? 'height: 210mm !important;'
                : 'height: 297mm !important;')
            }
          }
          .full-page {
            width: 100vw;
            height: 100vh;
            display: flex;
            page-break-after: always;
          }
          .half {
            flex: 1;
            box-sizing: border-box;
          }
          .kpi-graphics {
            canvas {
              width: 100% !important;
              height: 300px !important;
            }
          }
        }
        @media screen {
          .print-container {
            width: 100%;
          }
          .full-page {
            width: 100vw;
            height: 100vh;
            display: flex;
            margin-bottom: 24px;
          }
          .half {
            flex: 1;
            box-sizing: border-box;
          }
        }              
    `,
  })

  useEffect(() => {
    if (pdfController.loading) {
      setTimeout(() => {
        reactToPrintFn()
      }, 1000)
    }
  }, [pdfController.loading])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768) // Detectar vista móvil
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const getChartOptions = ({ options, flagIsMobile, type }) => {
    const baseOptions = options || {}

    let dataReturn = {
      ...baseOptions,
      plugins: {
        ...(baseOptions.plugins || {}),
        legend: {
          ...(baseOptions.plugins?.legend || {}),
          display: false,
          labels: {
            ...(baseOptions.plugins?.legend?.labels || {}),
            font: {
              size: 9,
              weight: 'bold',
            },
          },
        },
        datalabels: {
          ...(baseOptions.plugins?.datalabels || {}),
          font: {
            size: 9,
            weight: 'bold',
          },
          offset: 1,
          formatter: (value) => {
            return formatNumberWithCommas(value)
          },
        },
      },
      scales: {
        ...(baseOptions.scales || {}),
        x: {
          ...(baseOptions.scales?.x || {}),
          ticks: {
            ...(baseOptions.scales?.x?.ticks || {}),
            font: {
              size: 9,
              weight: 'bold',
            },
            callback: function (value) {
              return this.getLabelForValue(value).toUpperCase()
            },
          },
        },
        y: {
          ...(baseOptions.scales?.y || {}),
          ticks: {
            ...(baseOptions.scales?.y?.ticks || {}),
            font: {
              size: 9,
              weight: 'bold',
            },
            callback: function (value) {
              return String(value).toUpperCase()
            },
          },
        },
      },
    }

    if (type === 'pie') {
      dataReturn.plugins.datalabels.formatter = (value) => {
        return value.toFixed(2) + '%'
      }
    } else if (type === 'bar') {
      if (flagIsMobile) {
        dataReturn.plugins.legend.labels.font.size = 6
        dataReturn.plugins.datalabels.font.size = 10
        dataReturn.scales.x.ticks.font.size = 6
        dataReturn.scales.y.ticks.font.size = 6
        dataReturn.plugins.datalabels.offset = -10
      } else if (pdfController.horizontalPage) {
        dataReturn.plugins.datalabels.offset = -15
        dataReturn.plugins.datalabels.font.size = 15
        dataReturn.plugins.legend.labels.font.size = 15
        dataReturn.scales.x.ticks.font.size = 10
      } else {
        dataReturn.plugins.datalabels.offset = -20
        dataReturn.plugins.datalabels.font.size = 25
        dataReturn.plugins.legend.labels.font.size = 20
        dataReturn.scales.x.ticks.font.size = 15
      }
    } else if (type === 'line') {
      if (flagIsMobile) {
        dataReturn.plugins.legend.labels.font.size = 6
        dataReturn.plugins.datalabels.font.size = 10
        dataReturn.scales.x.ticks.font.size = 6
        dataReturn.scales.y.ticks.font.size = 6
        dataReturn.plugins.datalabels.offset = -15
      } else {
        dataReturn.plugins.datalabels.offset = -10
        dataReturn.plugins.datalabels.font.size = 10
        dataReturn.plugins.datalabels.font.weight = 'bold'
      }
    }

    return dataReturn
  }

  return (
    <div
      ref={contentRef}
      className={`print-container ${
        pdfController.horizontalPage && 'print-container-horizontal-page'
      } ${
        isMobile &&
        pdfController.horizontalPage &&
        'print-container-horizontal-page-mobile'
      }
      ${
        isMobile &&
        !pdfController.horizontalPage &&
        'print-container-vertical-page-mobile'
      }`}
    >
      <div className="full-page">
        <div className="half">
          <div className="admin-master-mayor-pdf-template">
            <div
              className="d-flex flex-row w-100 justify-content-between align-items-center"
              style={{ gap: '10px 10px' }}
            >
              <div style={{ flex: 1 }}>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <img src={TlajoLogo} style={{ height: 50 }} />
                  </div>
                  <div>
                    <span style={{ fontSize: 16 }}>
                      {moment().format('DD/MM/YYYY')}
                    </span>
                  </div>
                </div>
              </div>
              <div style={{ flex: 1, textAlign: 'right' }}></div>
            </div>

            <div
              className="d-flex flex-row w-100 first-row"
              style={{ gap: '10px 20px' }}
            >
              <div
                className="first-row-content"
                style={isMobile ? { width: '100%' } : { width: '60%' }}
              >
                <div
                  className="d-flex flex-row w-100"
                  style={{ gap: '10px 20px' }}
                >
                  <div style={{ width: 220, flex: 1 }}>
                    <div
                      className="mb-3 reports-details"
                      style={{ fontSize: 12 }}
                    >
                      <div className="d-flex">
                        <div className="text-bold" style={{ width: 80 }}>
                          Periodo:
                        </div>
                        <div style={{ flex: 1, fontStyle: 'italic' }}>
                          {filters?.date_type === 'ALL'
                            ? 'Generales'
                            : filters?.date_type === 'YEAR'
                            ? 'Anuales'
                            : filters?.date_type === 'MONTH'
                            ? 'Mensuales'
                            : filters?.date_type === 'WEEK'
                            ? 'Semanales'
                            : filters?.date_type === 'DAY'
                            ? 'Diarios'
                            : 'Generales'}
                        </div>
                      </div>

                      <div className="d-flex">
                        <div className="text-bold" style={{ width: 80 }}>
                          Vista por:
                        </div>
                        <div style={{ flex: 1, fontStyle: 'italic' }}>
                          {filters?.year && (
                            <>
                              <span className="subtitle">
                                Año {filters?.year}
                              </span>
                              <br />
                            </>
                          )}
                          {filters?.month && (
                            <>
                              <span className="subtitle">
                                Mes {monthsName[filters.month - 1]}
                              </span>
                              <br />
                            </>
                          )}
                          {filters?.week && (
                            <>
                              <span className="subtitle">
                                Semana {filters?.week}
                              </span>
                              <br />
                            </>
                          )}
                        </div>
                      </div>

                      <div className="d-flex">
                        <div className="text-bold" style={{ width: 80 }}>
                          Categorías:
                        </div>
                        <div style={{ flex: 1, fontStyle: 'italic' }}>
                          {counters?.categories?.length > 0 &&
                          filters?.array_group_category_id?.length > 0 ? (
                            counters?.categories
                              ?.slice(0, 4)
                              .map((category, index) => {
                                const findCategoryFilter =
                                  filters?.array_group_category_id?.find(
                                    (item) => item === category?.id
                                  )
                                if (!findCategoryFilter) return null
                                return (
                                  <span key={index} className="subtitle">
                                    {category?.name}
                                    {index <
                                      counters?.categories?.length - 1 && (
                                      <br />
                                    )}
                                  </span>
                                )
                              })
                          ) : (
                            <span className="subtitle">
                              Todas las categorías
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className="d-flex flex-row">
                        <div style={{ flex: 1 }}>
                          <div style={{ width: '95%' }} className="card p-2">
                            <div
                              style={{
                                color: '#f97316',
                                backgroundColor: '#ffe1c7',
                                width: 30,
                                height: 30,
                                verticalAlign: 'middle',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderRadius: '20%',
                              }}
                            >
                              <i
                                className="fas fa-check colorGreen"
                                style={{ fontSize: 16 }}
                              />
                            </div>
                            <div style={{ fontSize: 12, height: 40 }}>
                              Sistema de indicadores
                            </div>
                            <div style={{ fontSize: 20 }}>
                              {counters?.generalPercentage
                                ? counters?.generalPercentage >= 80
                                  ? 'Bueno'
                                  : counters?.generalPercentage >= 60
                                  ? 'Normal'
                                  : 'Regular'
                                : 'Regular'}
                            </div>
                          </div>
                        </div>
                        <div style={{ flex: 1 }}>
                          <div style={{ width: '95%' }} className="card p-2">
                            <div
                              style={{
                                color: '#f97316',
                                backgroundColor: '#ffe1c7',
                                width: 30,
                                height: 30,
                                verticalAlign: 'middle',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderRadius: '20%',
                              }}
                            >
                              <i
                                className="fas fa-check colorGreen"
                                style={{ fontSize: 16 }}
                              />
                            </div>
                            <div style={{ fontSize: 12, height: 40 }}>
                              Procentaje General
                            </div>
                            <div style={{ fontSize: 20 }}>
                              {counters?.generalPercentage || 0}%
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="observations-box mb-4 px-2">
                        <div className="header">
                          <h5>Observaciones</h5>
                        </div>
                        <div className="body">{pdfController.notes}</div>
                      </div>
                    </div>

                    {/* <div>
                      <div className="graphics-box col-12">
                        <div className="header">
                          <h5 className="text-left">
                            Canales{' '}
                            {filters?.date_type === 'ALL'
                              ? 'total'
                              : filters?.date_type === 'YEAR'
                              ? 'anuales'
                              : filters?.date_type === 'MONTH'
                              ? 'mensuales'
                              : filters?.date_type === 'WEEK'
                              ? 'semanales'
                              : filters?.date_type === 'DAY'
                              ? 'diarios'
                              : 'total'}
                          </h5>
                        </div>
                        <div className="body">
                          <div className={`legend-pdf`}>
                            <div className="legend-item mr-3">
                              <h5>Web</h5>
                              <p>{formatNumberWithCommas(counters?.web)}</p>
                            </div>
                            <div className="legend-item mr-3">
                              <h5>App</h5>
                              <p>{formatNumberWithCommas(counters?.app)}</p>
                            </div>
                            <div className="legend-item">
                              <h5>Tlajochat</h5>
                              <p>
                                {formatNumberWithCommas(counters?.tlajochat)}
                              </p>
                            </div>
                          </div>
                          <div className="chart">
                            <KpiCustomGraphicPie
                              data={counters?.countersByDateFilterPie}
                              options={{
                                ...getChartOptions({
                                  options:
                                    counters?.countersByDateFilterPieOptions,
                                  flagIsMobile: false,
                                  type: 'pie',
                                }),
                              }}
                              fromPdf={true}
                            />
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div className="percentages-by-categories-box">
                      <div className="header">
                        <h5>Eficiencia de atención</h5>
                      </div>
                      <div className="body">
                        <ul style={{ marginBottom: 1 }}>
                          {counters?.categories
                            ?.slice(0, 15)
                            .map((category, index) => {
                              return (
                                <li key={`category-${category?.name}`}>
                                  <div>
                                    <span>
                                      <img
                                        src={category?.icon}
                                        alt={`icon-category-${index}`}
                                      />{' '}
                                      {category?.name}
                                    </span>
                                    <span>{category?.percentage}%</span>
                                  </div>
                                </li>
                              )
                            })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {!isMobile && (
                <div style={{ flex: 1, textAlign: 'right' }}>
                  <div
                    className="half"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      height: '100%',
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <div className="lines-graphic">
                        <div className="graphics-box col-12 counters-page-break">
                          <div className="header">
                            <h5 className="text-left">
                              % de resueltos{' '}
                              {filters?.date_type === 'ALL'
                                ? 'total'
                                : filters?.date_type === 'YEAR'
                                ? 'anuales'
                                : filters?.date_type === 'MONTH'
                                ? 'mensuales'
                                : filters?.date_type === 'WEEK'
                                ? 'semanales'
                                : filters?.date_type === 'DAY'
                                ? 'diarios'
                                : 'total'}
                            </h5>
                          </div>
                          <div className="body">
                            <div className="chart">
                              <KpiCustomGraphicLine
                                lineData={counters?.counterByDateFilterLines}
                                lineOptions={{
                                  ...getChartOptions({
                                    options:
                                      counters?.counterByDateFilterLinesOptions,
                                    flagIsMobile: isMobile,
                                    type: 'line',
                                  }),
                                }}
                                fromPdf={true}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="bars-graphic" style={{ flex: 1 }}>
              {counters?.counterByDateFilter && (
                <div className="graphics-box col-12">
                  <div className="header">
                    <h5 className="text-left">
                      Reportes{' '}
                      {filters?.date_type === 'ALL'
                        ? 'Generales'
                        : filters?.date_type === 'YEAR'
                        ? 'Anuales'
                        : filters?.date_type === 'MONTH'
                        ? 'Mensuales'
                        : filters?.date_type === 'WEEK'
                        ? 'Semanales'
                        : filters?.date_type === 'DAY'
                        ? 'Diarios'
                        : 'Generales'}
                    </h5>
                  </div>

                  <div className="body">
                    <div className={`legend-pdf`}>
                      <div className="legend-item mr-3">
                        <h5>Generados</h5>
                        <p>{formatNumberWithCommas(counters?.generated)}</p>
                      </div>
                      <div className="legend-item mr-3">
                        <h5>En proceso</h5>
                        <p>{formatNumberWithCommas(counters?.in_process)}</p>
                      </div>
                      <div className="legend-item mr-3">
                        <h5>Atendidos</h5>
                        <p>{formatNumberWithCommas(counters?.resolved)}</p>
                      </div>
                      <div className="legend-item">
                        <h5>Efectividad</h5>
                        <p>{counters?.effectiveness}%</p>
                      </div>
                    </div>
                    <div className="chart">
                      <KpiCustomGraphicBar
                        barDataStatus={counters?.counterByDateFilter}
                        barOptions={{
                          ...getChartOptions({
                            options: counters?.counterByDateFilterOptions,
                            flagIsMobile: isMobile,
                            type: 'bar',
                          }),
                        }}
                        fromPdf={true}
                        showStackedDatalabels={true}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            {isMobile && (
              <div style={{ flex: 1, textAlign: 'right' }}>
                <div
                  className={`half line-graphic-mobile`}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <div className="lines-graphic">
                      <div className="graphics-box col-12 counters-page-break">
                        <div className="header">
                          <h5 className="text-left">
                            % de resueltos{' '}
                            {filters?.date_type === 'ALL'
                              ? 'total'
                              : filters?.date_type === 'YEAR'
                              ? 'anuales'
                              : filters?.date_type === 'MONTH'
                              ? 'mensuales'
                              : filters?.date_type === 'WEEK'
                              ? 'semanales'
                              : filters?.date_type === 'DAY'
                              ? 'diarios'
                              : 'total'}
                          </h5>
                        </div>
                        <div className="body">
                          <div className="chart">
                            <KpiCustomGraphicLine
                              lineData={counters?.counterByDateFilterLines}
                              lineOptions={{
                                ...getChartOptions({
                                  options:
                                    counters?.counterByDateFilterLinesOptions,
                                  flagIsMobile: isMobile,
                                  type: 'line',
                                }),
                              }}
                              fromPdf={true}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {isMobile && pdfController?.dynamicTable && (
              <div className="admin-master-mayor-pdf-template">
                <CategoriesTableAdminMasterMayor
                  counters={counters?.counterByDateFilterCategories}
                  // splitTable={true}
                  expandAllRows={true}
                  pdfViewer={counters?.counterByDateFilter?.labels?.length > 8}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {!isMobile && pdfController?.dynamicTable && (
        <div className="full-page">
          <div className="half">
            <div style={{ flex: 1 }}>
              <div className="admin-master-mayor-pdf-template">
                <CategoriesTableAdminMasterMayor
                  counters={counters?.counterByDateFilterCategories}
                  // splitTable={true}
                  expandAllRows={true}
                  pdfViewer={counters?.counterByDateFilter?.labels?.length > 8}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default AdminMasterMayorPdfTemplate
